import { render, staticRenderFns } from "./BaseInputRoom.vue?vue&type=template&id=2ab1b58c&scoped=true&"
import script from "./BaseInputRoom.vue?vue&type=script&lang=js&"
export * from "./BaseInputRoom.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRoom.vue?vue&type=style&index=0&id=2ab1b58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1b58c",
  null
  
)

export default component.exports